import { render } from "./Splesh.vue?vue&type=template&id=50ccf8b6"
import script from "./Splesh.vue?vue&type=script&lang=js"
export * from "./Splesh.vue?vue&type=script&lang=js"

import "./Splesh.vue?vue&type=style&index=0&id=50ccf8b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__